var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1bb12e9555b8130ae74ac984867d896e3769775b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["zz-platform-pages@zhuanzhuan"]={id:"1bb12e9555b8130ae74ac984867d896e3769775b"};
      